var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-custom-scrollbar",
    {
      staticClass: "workspace-module-container",
      attrs: { id: "workspace-result-designs" }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ]
        },
        [_vm._v(_vm._s(_vm.lengthUploadedPhotos))]
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "result-designs-container" } },
        _vm._l(_vm.photos, function(photo, photoId) {
          return _c("div", { staticClass: "project-preview" }, [
            _c("img", {
              staticClass: "project-preview-image img-central",
              attrs: { src: _vm.getPhotoDataUrl(photoId) },
              on: {
                click: function($event) {
                  _vm.showModal(
                    "modal-result-photo",
                    _vm.getPhotoDataUrl(photoId)
                  )
                }
              }
            })
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }